import { Row } from "antd";
import { YhBox } from "@/components/YhBox";
import { useGlobalModel } from "@/model/globalModel";
import { SearchItem } from "@/components/YhPageHeader/item";
import { openDataModel } from "./openDataModel";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";

export const OpenSearchBox = () => {

    const { accountTypeDs } = useGlobalModel()
    const {
        searchParam,
        onSearch,
        onReset,
        updateSearchParam,
        loadData
    } = openDataModel();

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "审核状态",
            fieldName: "status",
            size: "small",
            options: [
                // { label: "初始", value: 0 },
                { label: "审核中", value: 1 },
                { label: "审核通过", value: 2 },
                // { label: "撤回", value: 3 },
                { label: "审核驳回", value: 8 },
                // { label: "失败", value: 9 }
            ],
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 4,
            span: 4,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    ...data,
                    startTime: data.time[0] !== '' ? data.time[0] + ' 00:00:00' : undefined,
                    endTime: data.time[1] !== '' ? data.time[1] + ' 23:59:59' : undefined,
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset,
        }
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
